// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__3l_ne","wrapper-nopadding":"wrapper-nopadding__3zlgB","loading":"loading__2whT2","error":"error__WA2iL","table-loading":"table-loading__1A_DV","empty-val":"empty-val__2TR84","panelheader-tools":"panelheader-tools__2psEy","propsPanels":"propsPanels__PQvQX","new":"new__NglUz","marginLm":"marginLm__3yxK6","marginRm":"marginRm__13jhY","fullWidth":"fullWidth__1eNlu","fullHeight":"fullHeight__18qJo","noData":"noData__2A80J","noflow":"noflow__1wW1-","desc":"desc__3R2Yt"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Application/coms/ApplicationDetail/coms/FlowsView/coms/Flows/styles.scss
// module id = 2213
// module chunks = 1